// 登录页：原生 form POST /login，由 daemon 302 回 next。
// 不要换成 fetch；fetch 跟 302 在 same-origin 下会把响应体当 JSON 解析，session cookie 也不会落地。

import { createFileRoute } from "@tanstack/react-router";

interface LoginSearch {
  from?: string;
}

export const Route = createFileRoute("/login")({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    from: typeof search.from === "string" ? search.from : undefined,
  }),
  component: LoginPage,
});

function LoginPage() {
  const { from } = Route.useSearch();
  const next = from || "/";
  return (
    <div className="mx-auto mt-24 max-w-sm rounded border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-6 shadow-sm">
      <h1 className="mb-4 text-lg font-semibold">登录 HBH-996 操作台</h1>
      <form method="POST" action="/login" className="space-y-3">
        <label className="block text-sm">
          <span className="mb-1 block text-[hsl(var(--muted-foreground))]">用户名</span>
          <input
            name="username"
            autoComplete="username"
            required
            className="w-full rounded border border-[hsl(var(--input))] bg-transparent px-2 py-1.5"
          />
        </label>
        <label className="block text-sm">
          <span className="mb-1 block text-[hsl(var(--muted-foreground))]">密码</span>
          <input
            name="password"
            type="password"
            autoComplete="current-password"
            required
            className="w-full rounded border border-[hsl(var(--input))] bg-transparent px-2 py-1.5"
          />
        </label>
        <input type="hidden" name="next" value={next} />
        <button
          type="submit"
          className="w-full rounded bg-[hsl(var(--primary))] px-3 py-1.5 text-sm font-medium text-[hsl(var(--primary-foreground))] hover:opacity-90"
        >
          登录
        </button>
      </form>
    </div>
  );
}
